import { increaseProfileScoreModal } from 'eventNames/Profile/ProfileScore';

const analyticEventsNames = {
  increaseProfileScoreModal,
};

export default analyticEventsNames;
